import { useState } from "react";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Square, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const activeDate = (svc) => {
  const now = Date.now();
  const dates = (svc.dates?.length ? svc.dates : [svc.date_time]).filter(Boolean);
  const act = dates.filter((d) => { const t = new Date(d).getTime(); return t <= now && now <= t + 864e5; });
  return act.length ? act.sort().at(-1) : null;
};

export function EndServiceButton({ svc, currentUser, onEnded }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const canEnd = svc.status === "coperto" && (svc.is_signed_up || currentUser.role === "coordinatore");
  const d = canEnd ? activeDate(svc) : null;
  if (!d) return null;
  const ended = svc.ended_dates?.[d];
  if (ended) {
    return (
      <span className="text-xs text-emerald-700 font-semibold flex items-center gap-1" data-testid={`service-ended-${svc.id}`}>
        <CheckCircle2 className="h-4 w-4" /> Terminato alle {ended.at.slice(11, 16)} ({ended.hours} h) da {ended.by_name}
      </span>
    );
  }
  const confirm = async () => {
    setBusy(true);
    try {
      await api.post(`/services/${svc.id}/end`);
      toast.success("Fine servizio registrato: ore effettive calcolate");
      onEnded?.();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore");
    } finally {
      setBusy(false);
      setOpen(false);
    }
  };
  const start = new Date(d).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
  return (
    <>
      <Button size="sm" onClick={() => setOpen(true)} data-testid={`end-service-${svc.id}`} className="rounded-full bg-[#D32F2F] hover:bg-[#B71C1C] text-white font-semibold">
        <Square className="h-3.5 w-3.5 mr-1 fill-white" /> Fine servizio
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="end-service-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Registrare la fine del servizio?</AlertDialogTitle>
            <AlertDialogDescription>
              Le ore effettive di tutti i volontari assegnati a «{svc.event_name}» saranno calcolate dall'inizio programmato ({start}) a adesso. Il coordinatore potrà correggerle dal Consuntivo.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="end-service-cancel">Annulla</AlertDialogCancel>
            <AlertDialogAction onClick={confirm} disabled={busy} data-testid="end-service-confirm" className="bg-[#D32F2F] hover:bg-[#B71C1C]">Conferma fine servizio</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
